import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5c9df5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center gap-2 text-sm text-textPrimary whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dynamicComponent))),
    (_ctx.legendIcon)
      ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 0,
          icon: _ctx.legendIcon,
          color: _ctx.legendColor
        }, null, 8, ["icon", "color"]))
      : (!_ctx.dynamicComponent)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["w-4 h-4 rounded-full", _ctx.defineBgColor()])
          }, null, 2))
        : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.text), 1)
  ]))
}